module.exports = __webpack_public_path__ + "static/media/brand-firehub-white.33039d5c.svg";